'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

/**
 * A simple flip transition.
 * @property {Array} x
 *   Flips on the x axis
 * @property {Array} y
 *   Flips on the y axis
 */
var flip = {
  x: (0, _styledComponents.css)(['backface-visibility:hidden;transform:perspective(200vw) rotate3d(0,1,0,calc(180deg * var(--direction,-1) * var(--time,1)));']),
  y: (0, _styledComponents.css)(['backface-visibility:hidden;transform:perspective(200vh) rotate3d(1,0,0,calc(180deg * var(--direction,-1) * var(--time,1)));'])
};

exports.default = flip;
//# sourceMappingURL=flip.js.map